import { render, staticRenderFns } from "./AdminAria.vue?vue&type=template&id=e5e1566a&"
import script from "./AdminAria.vue?vue&type=script&lang=js&"
export * from "./AdminAria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports